import axios from 'axios'
import { addDays, isAfter, startOfWeek, parse } from 'date-fns'
import React, { useEffect, useMemo, useState, useRef } from 'react'
import { CSVLink } from 'react-csv'
import ConfirmActionComp from '../components/vendor/ConfirmActionComp'
import ReconfirmActionComp from '../components/vendor/ReconfirmActionComp'
import ExpediteActionComp from '../components/vendor/ExpediteActionComp'
import { useTranslation } from 'react-i18next'
import i18next from 'i18next'
import { useReactTable } from '@tanstack/react-table'
import { weeksInBetween } from '../screens/vendor/ConfirmPo'
import { CSSProperties, FunctionComponent } from 'react'
import Select, { ClearIndicatorProps, components } from 'react-select'
import { CSSObject } from '@emotion/serialize'
import DatePicker from 'react-datepicker' // Import DatePicker from react-datepicker
import 'react-datepicker/dist/react-datepicker.css' // Import DatePicker styles
import { format } from 'date-fns'
import { isValid } from 'date-fns'
import Cookies from 'js-cookie'
import { CartState } from '../Context/Context'
import { useNavigate } from 'react-router'
import { FixedSizeList as List } from 'react-window';
import { formatDateFit } from '../screens/buyer/BuyerRequestDetails'
import { CommonAPICall } from '../CommonAPiContext/context'
import axiosInstance, { isTokenExpired, portInUseForAPI } from '../api/axiosInstance'
export const handleDownload = async (poNumber, setBanner, setMessage, setLoading, rev) => {
  if (setLoading) setLoading(true)
  try {
    // Define the download link with query parameters
    const downloadLink = `${process.env.REACT_APP_API_DOMAIN}:${portInUseForAPI}/api/download-pdf?poNumber=${poNumber}`;
    const role = Cookies.get('role')
    const user = JSON.parse(localStorage.getItem('userData'))
    const auth_id = localStorage.getItem('auth_state')
    // Make the API request using Axios
    const response = await axios.get(downloadLink, {
      responseType: 'blob', // Important to specify the response type as blob
      headers: {
        'Content-Type': 'application/pdf',
        'Authorization': `Bearer ${Cookies.get('idcs_user_assertion')}`, // Add the bearer token to the headers
        'Role': Cookies.get('role'),
        'X-Source-Ref': role.toLowerCase() === "vendor" && user?.supplierId,
        'X-Trace-Id': auth_id
      },
    });


    // Create a URL for the blob
    const url = window.URL.createObjectURL(new Blob([response.data]));

    // Create a link element
    const anchor = document.createElement('a');
    anchor.href = url;

    const s = (v) => (v ?? '').toString();

    // Normalize, trim, and strip invisible/control chars
    const clean = (v) =>
      s(v)
        .normalize('NFC')
        .replace(/[\u200B-\u200D\uFEFF\u00A0]/g, '')  // zero-width & NBSP
        .replace(/[\u0000-\u001F]/g, '')              // control chars
        .trim();
    const safeBase = clean("purchase_history")
    const safeVendor = clean(poNumber);
    const safeRev = clean(rev);
    const rawName = safeRev ? `${safeBase}_${safeVendor}_${safeRev}` : safeBase;
    const sanitized = rawName.replace(/[\\/:*?"<>|]+/g, '_');

    anchor.download = `${sanitized}.pdf`
    // anchor.download = 'purchase_history.pdf'; // Set the file name


    // Append the link to the body
    document.body.appendChild(anchor);

    // Programmatically click the link to trigger the download
    anchor.click();

    // Remove the link from the document
    document.body.removeChild(anchor);

    // Release the URL object
    window.URL.revokeObjectURL(url);
    setMessage(
      <>
        <span style={{ color: 'green', fontWeight: 'bold' }}>File Downloaded Successfully</span>
      </>
    )
    setBanner(true)
    setLoading(false)
  } catch (error) {
    let errorMessage = ""
    try {
      if (!(error.response.data instanceof Blob)) {
        throw new Error("Input is not a Blob");
      }
      const text = await error.response.data.text();   // Convert Blob → text
      errorMessage = JSON.parse(text)?.message          // Try parsing JSON
    } catch (err) {
      // If parsing fails, return raw text instead of throwing
      try {
        const text = await error.response.data.text();
        errorMessage = "An error encountered while processing the file"
      } catch {
        errorMessage = "An error encountered while processing the file"
      }
    }
    setMessage(
      <>
        <span style={{ color: 'red', fontWeight: 'bold' }}>{errorMessage}</span>
      </>
    )
    setBanner(true)
    setLoading(false)
  }
}

export const downloadCSV = (fileName, data, tagName = i18next.t("UtilPage.DownloadCSV")) => {
  // const translatedTagName = i18next.t(tagName);
  const downloadCSVfile = () => {
    const csvData = convertToCSV(data)
    const blob = new Blob([csvData], { type: 'text/csv' })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = 'data.csv'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  }

  const convertToCSV = (data) => {
    const escapeValue = (value) => {
      if (value === null || value === undefined) return ''
    
      // remove line breaks from the data itself
      const str = value.toString().replace(/[\r\n]+/g, ' ').trim()
    
      if (/^\d{2}\/\d{2}\/\d{4}/.test(str)) {
        return `="${str}"`
      }
    
      const escaped = str.replace(/"/g, '""')
    
      // also quote on \r, as a safety net
      if (/[",\r\n]/.test(escaped)) {
        return `"${escaped}"`
      }
      return escaped
    }
    const header = Object.keys(data[0]).join(',')
    const body = data.map((row) =>
      Object.entries(row).map(([key, value]) => {
        
        if (key === 'DATE_LAST_UPDATED' || key === 'updated_at' || key === 'created_at' || key === 'CREATION_DATE') {
          value = convertToLocalDate(value)
        }
  
        return escapeValue(value)
      }).join(',')
    ).join('\n')
  
    return header + '\n' + body
  }
  return (
    // <CSVLink
    //   data={data}
    //   filename={fileName}
    //   // headers={headers}
    //   className="bg-[#415da1] border rounded p-2 font-medium text-xs text-white  ">

    //   {i18next.t('UtilPage.DownloadCSV')}
    // </CSVLink>
    <button
      class="bg-[#415da1] p-2 rounded-md outline-none text-white  min-w-max"

      onClick={downloadCSVfile}

    >
      {tagName}
    </button>
  )
}
export const formatDate = (reqDate) => {
  const year = reqDate?.slice(0, 4)
  const month = reqDate?.slice(4, 6)
  const day = reqDate?.slice(6, 8)
  const date = new Date(`${year}-${month}-${day}`)
  const formattedDate = date.toISOString()?.slice(0, 10)

  return formattedDate
}
export const dateformatDDMMYEAR = (reqDate) => {
  const year = reqDate?.slice(0, 4)
  const month = reqDate?.slice(4, 6)
  const day = reqDate?.slice(6, 8)
  const formattedDate = month + '/' + day + '/' + year

  return formattedDate
}

export const reasonCodes = [
  i18next.t('ReasonCodeList.CapacityorProductionSlowDown'),
  i18next.t('ReasonCodeList.EquipmentMoldMaintenance'),
  i18next.t('ReasonCodeList.LCLShipmentConsolidation'),
  i18next.t('ReasonCodeList.MaterialorLaborShortage'),
  i18next.t('ReasonCodeList.PublicHoliday'),
  i18next.t('ReasonCodeList.QualityIssueProductChange'),
  i18next.t('ReasonCodeList.ForceMajeureWeatherEvents'),
  i18next.t('ReasonCodeList.FreightForwarderConsolidation'),
  i18next.t('ReasonCodeList.SpaceConstraints'),
  i18next.t('ReasonCodeList.VesselDelay'),
  i18next.t('ReasonCodeList.Other')
]
export const reasonCodesEN = [
  'Capacity or Production Slow Down',
  'Equipment/Mold Maintenance',
  'LCL Shipment Consolidation',
  'Material or Labor Shortage',
  'Public Holiday',
  'Quality Issue / Product Change',
  'Force Majeure / Weather Events',
  'Freight Forwarder Consolidation',
  'Space Constraints',
  'Vessel Delay',
  'Other'
]
export const reasonCodesMN = [
  '产能或生产放缓',
  '设备/模具维护',
  '拼箱货物整合',
  '材料或劳动力短缺',
  '公共假期',
  '质量问题/产品变更',
  '不可抗力/天气事件',
  '货运代理整合',
  '空间限制', ,
  '船舶延迟',
  '其他'
]

export const handlePODetailsClick = (user_role, value) => {
  // const navigate  = useNavigate()
  const detailsUrl = `/${user_role}/po_list/po_record/${value}`
  const popupWindow = window.open(
    detailsUrl,
    '_blank',
    'width=1100,height=800,resizable=yes,scrollbars=yes'
  )
  // Focus the new popup window (optional)
  // window.location.href=detailsUrl
  if (popupWindow) {
    popupWindow.focus()
  }
}

export const handleCRHistoryClick = (poNumber, sku) => {
  const detailsUrl = `/cr_history/${poNumber}/${sku}`
  const popupWindow = window.open(
    detailsUrl,
    '_blank',
    'width=950,height=800,resizable=yes,scrollbars=yes'
  )

  if (popupWindow) {
    popupWindow.focus()
  }
}

export const handleCRDetailsClick = (user_role, value) => {
  const detailsUrl = `/${user_role}/po_change_requests/request_details/${value}`
  const popupWindow = window.open(
    detailsUrl,
    '_blank',
    'width=1100,height=800,resizable=yes,scrollbars=yes'
  )

  // Focus the new popup window (optional)
  if (popupWindow) {
    popupWindow.focus()
  }
}

export function checkPd(weekString) {
  if (weekString === null || weekString === undefined) return true
  const [week, year] = weekString.split('.').map(Number)
  const isoWeekStart = startOfWeek(new Date(year + 2000, 0, 1), {
    weekStartsOn: 1
  })
  // ADDED 2 WEEKS: push the past-due deadline out by 2 weeks
  const calculatedDate = addDays(isoWeekStart, (week + 2) * 7)
  const today = new Date()
  return isAfter(today, calculatedDate)
}

export const getSortableValue = (value) => {
  if (value === null || value === undefined) return -Infinity;

  // Handle BLANK explicitly
  if (value === 'BLANK') return -Infinity;

  // Numbers → sort naturally
  if (typeof value === 'number') return value;

  // ShipWeek (WW.YY)
  if (typeof value === 'string' && /^\d{1,2}\.\d{2}$/.test(value)) {
    const [week, year] = value.split('.').map(Number);
    const fullYear = year >= 70 ? 1900 + year : 2000 + year;
    return fullYear * 100 + week;
  }

  // Numeric strings ("10", "2")
  if (!isNaN(value)) return Number(value);

  // Fallback: string sort
  return value.toString().toLowerCase();
};


export function Filter({
  filterValue = {}, column, table, headers, headerGroup, columnFilters,
  values, setValues, HeaderText, width, header, tableId, ClearState, hftid
}) {

  const [selectedValue, setSelectedValue] = useState([]); // State to manage selected values
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [searchBarValue, setSearchBarValue] = useState(''); // State to manage selected values
  const [searchResult, setSearchResult] = useState(null);
  const [batchSize, setBatchSize] = useState(200); // Default batch size
  const { addFilterData } = CommonAPICall()
  const handleDateChange = (dates) => {
    const [start, end] = dates;

    if (start != null && end != null) {
      try {
        const startFormatted = format(start, 'ww.yy');
        const endFormatted = format(end, 'ww.yy');
        const dateRangeString = `${startFormatted}-${endFormatted}`;

        column.setFilterValue({ start, end });
        setStartDate(start);
        setEndDate(end);

        const localStorageKey = 'all_selected_values';
        let allSelectedValues = JSON.parse(localStorage.getItem(localStorageKey)) || [];
        allSelectedValues = allSelectedValues.filter(item => item.columnId !== column.id);
        allSelectedValues.push({
          columnId: column.id,
          values: dateRangeString
        });
        try {
          localStorage.setItem(localStorageKey, JSON.stringify(allSelectedValues));
        } catch (error) {
        }
      } catch (error) {
      }
    } else if (start != null && end == null) {
      setStartDate(start);
      setEndDate(null);
    } else if (start == null && end != null) {
      setEndDate(end);
      setStartDate(null);
    } else {
      setStartDate(null);
      setEndDate(null);
      column.setFilterValue('');
    }
  };
  const handlechangedateFormat = (dates) => {
    const [start, end] = dates;
    if (start != null && end != null) {
      try {
        // const startFormatted = format(start, 'ww.yy');
        // const endFormatted = format(end, 'ww.yy');
        // const dateRangeString = `${startFormatted}-${endFormatted}`;

        setStartDate(start);
        setEndDate(end);
        column.setFilterValue({ start, end });

        const localStorageKey = 'all_selected_values';
        let allSelectedValues = JSON.parse(localStorage.getItem(localStorageKey)) || [];
        allSelectedValues = allSelectedValues.filter(item => item.columnId !== column.id);
        allSelectedValues.push({
          columnId: column.id,
          values: { start, end }
        });
        try {
          localStorage.setItem(localStorageKey, JSON.stringify(allSelectedValues));
        } catch (error) {
        }
      } catch (error) {
      }
    } else if (start != null && end == null) {
      setStartDate(start);
      setEndDate(null);
    } else if (start == null && end != null) {
      setEndDate(end);
      setStartDate(null);
    } else {
      setStartDate(null);
      setEndDate(null);
      column.setFilterValue('');
    }
  };

  useEffect(() => {
    if (startDate && endDate && columnFilters.length === 0) {
      setStartDate(null);
      setEndDate(null);
    }
  }, [columnFilters]);



  useEffect(() => {

    if (hftid && tableId) {

      if (filterValue?.clFilter?.some(item => item.column === column.id)) {
        const value = filterValue?.clFilter?.find((data) => data?.column === column.id)?.values
        if (value.some(item => typeof item === 'number')) {
          column.setFilterValue(value);
        }
        else if (value?.length && value[0] !== '') {
          const filterarray = value?.map((data) => {
            return {
              label: data,
              value: data
            }
          })


          setSelectedValue(filterarray);
          const selectedValuesAsString = filterarray.map(option => option.value).join(', ')
          column.setFilterValue(selectedValuesAsString);
          setSearchBarValue(selectedValuesAsString);
        }


      }
      else {
        setSelectedValue([]);
        column.setFilterValue('');
      }

    }

  }, [tableId, column.id, ClearState, filterValue]);

  const handleChange = (selectedOptions) => {

    setSelectedValue(selectedOptions);



    const selectedValuesAsString = selectedOptions.map(option => option.value)?.join(', ');

    column.setFilterValue(selectedValuesAsString);
    setSearchBarValue(selectedValuesAsString);
    const arrayVAlue = selectedValuesAsString?.split(',')
    if (hftid && tableId) {
      addFilterData(
        {
          hftUserId: hftid,
          tableName: tableId,
          clFilter: [
            {
              column: column.id,
              values: arrayVAlue?.length && arrayVAlue[0] !== '' ? arrayVAlue : []
            }
          ]

        }

      )
    }

  };

  const searchInBatches = (query) => {
    let found = false;
    let batchIndex = 0;
    const data = column.getFacetedUniqueValues().keys();

    while (!found && batchIndex * batchSize < data.length) {
      const currentData = Array.from(data).slice(batchIndex * batchSize, (batchIndex + 1) * batchSize);
      const result = currentData.find(item => item.includes(query));

      if (result) {
        setSearchResult(result);
        found = true;
      } else {
        batchIndex++;
      }
    }

    if (!found) {
      setSearchResult(null);
    }
  };
  
  useEffect(() => {
    const currentFilter = columnFilters?.find(
      (filter) => filter.id === column.id
    );
  
    const value = currentFilter?.value;
  
    if (Array.isArray(value) && value.length) {
      setSelectedValue(
        value.map((item) => ({
          label: item,
          value: item,
        }))
      );
    } else if (typeof value === 'string' && value.trim()) {
      setSelectedValue(
        value.split(',').map((item) => ({
          label: item.trim(),
          value: item.trim(),
        }))
      );
    } else {
      setSelectedValue([]);
    }
  }, [columnFilters, column.id]);

  const firstValue = table
    .getPreFilteredRowModel()
    .flatRows[0]?.getValue(column.id);

  const columnFilterValue = column.getFilterValue();
  const sortedUniqueValues = React.useMemo(() => {
    if (typeof firstValue === 'number') return [];

    return Array.from(column.getFacetedUniqueValues().keys()).sort((a, b) => {
      const aVal = getSortableValue(a);
      const bVal = getSortableValue(b);

      // Handle BLANK explicitly → always first
      if (aVal === -Infinity && bVal === -Infinity) return 0;
      if (aVal === -Infinity) return -1;
      if (bVal === -Infinity) return 1;

      // Numbers → numeric ASCENDING
      if (typeof aVal === 'number' && typeof bVal === 'number') {
        return aVal - bVal;
      }

      // Strings → locale compare ASCENDING
      return aVal
        .toString()
        .localeCompare(bVal.toString(), undefined, {
          numeric: true,
          sensitivity: 'base',
        });
    });
  }, [column.getFacetedUniqueValues()]);



  const { t } = useTranslation();
  const headerWidth = header.getSize();
  const handleSearch = (value) => {
    return sortedUniqueValues.slice(0, 100).map((value) => ({
      value,
      label: value
    }))
  }
  const saveFilter = (id, hftid, tableId) => {

    setTimeout(() => {
      addFilterData({
        hftUserId: hftid,
        tableName: tableId,
        clFilter: [
          {
            column: id,
            values: column?.getFilterValue(),
          },
        ],
      });
    }, 0);
  }
  return (

    <>
      <div className="flex justify-center items-center relative">
        {typeof firstValue === 'number' ? (
          <div>
            <div className='flex gap-1' style={{ height: '38px' }}>
              <DebouncedInput
                type='number'
                value={columnFilterValue?.[0] ?? ''}
                placeholder='Min'
                onChange={(value) => {
                  if (!value)
                    return

                  const minValue = value === '' ? '' : Number(value);
                  const maxValue = columnFilterValue?.[1] ?? '';

                  // If min is greater than max, clear the max value
                  if (minValue !== '' && minValue > (maxValue === '' ? Infinity : maxValue)) {
                    column.setFilterValue([minValue, '']);
                  } else {
                    column.setFilterValue([minValue, maxValue]);
                  }
                  saveFilter(column.id, hftid, tableId)
                }}
                className='border shadow rounded'
                hftid={hftid}
                tableId={tableId}
                column={column.id}
                side='left'
                arrayData={columnFilterValue}
              />
              <DebouncedInput
                type='number'
                value={columnFilterValue?.[1] ?? ''}
                placeholder='Max'
                onChange={(value) => {
                  if (!value)
                    return
                  const maxValue = value === '' ? '' : Number(value);
                  const minValue = columnFilterValue?.[0] ?? '';

                  // If max is less than min, clear the min value
                  if (maxValue !== '' && maxValue < (minValue === '' ? -Infinity : minValue)) {
                    column.setFilterValue(['', maxValue]);
                  } else {
                    column.setFilterValue([minValue, maxValue]);
                  }
                  saveFilter(column.id, hftid, tableId)
                }}
                className='border shadow rounded'
                hftid={hftid}
                tableId={tableId}
                column={column.id}
                side='right'
                arrayData={columnFilterValue}
              />
            </div>



            <div className='' />
          </div>
        ) : column.id === 'REQ_SW_DATE' ||
          column.id === 'ORG_SW_DATE' ||
          column.id === 'CUR_SW_DATE' ||
          column.id === 'ONTIMETARGET_SW_DATE' ? (
          <div style={{ width: headerWidth > 70 ? headerWidth : 70 }} className='mt-1'>
            <DatePicker
              selectsRange={true}
              startDate={startDate}
              endDate={endDate}
              onChange={handleDateChange}
              isClearable={true}
              className={`h-9 border border-gray-400 rounded-none w-full`}
              popperClassName='react-datepicker__week-number'
              wrapperClassName="w-full"
              placeholderText='Select Date Range'
              showWeekNumbers
              showIcon
              scrollableYearDropdown
              calendarStartDay={1}
              filterDate={(date) => date.getDay() === 1}
              showYearDropdown
              dateFormat='dd/MM/yyyy'
              popperPlacement="bottom-start"
            />
            <div className='h-1' />
          </div>
        ) : column.id === 'created_at' ||
          column.id === 'updated_at' ||
          column.id === 'DATE_LAST_UPDATED' ||
          column.id === 'date' || column.id === 'createdDate' ||
          column.id === 'CREATION_DATE' || column.id === 'UPDATEDAT'
          ? (
            <div style={{ width: headerWidth > 70 ? headerWidth : 70 }}>
              <DatePicker
                key={headerWidth}
                selectsRange={true}
                startDate={startDate}
                endDate={endDate}
                onChange={handlechangedateFormat}
                isClearable={true}
                className={`h-9 border border-gray-400 rounded w-full items-center flex`}
                wrapperClassName="w-full items-center flex"
                popperClassName='react-datepicker__week-number custom-calendar  '
                calendarClassName="custom-calendar"
                placeholderText='Select Date Range'
                showWeekNumbers
                showIcon
                popperPlacement="bottom-start"
                scrollableYearDropdown
                calendarStartDay={1}
                // filterDate={(date) => date.getDay() === 1}
                showYearDropdown
              // dateFormat='dd/MM/yyyy'
              />
              <div className='h-1' />
            </div>
          ) : (
            <>
              <Select
                closeMenuOnSelect={false}
                isMulti
                placeholder={`Search`}
                options={sortedUniqueValues.map((value) => ({
                  value,
                  label: value
                }))}
                value={selectedValue}
                onChange={handleChange}
                className='border border-gray-300 border-solid rounded h-9 focus:border-blue-100 focus:ring-blue-300 css-b62m3t-container'
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    boxShadow: state.isFocused ? 'none' : 'none',
                  }),
                  input: (provided) => ({
                    ...provided,
                    maxHeight: '200px',
                    overflowY: 'auto',
                    width: headerWidth,
                    minWidth: headerWidth,
                  }),
                  menu: (provided) => ({
                    ...provided,
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    width: '100%',
                  }),
                  menuList: (provided) => ({
                    ...provided,
                    maxHeight: '200px',
                    overflowY: 'auto',
                  }),
                }}
              />
              <div className='h-1' />
            </>
          )}
      </div>
    </>
  );
}



export function TestFilterComp() {
  return (
    <div>
      <input type='text' placeholder='Test Filter' />
    </div>
  )
}

export function CustomFilter({ selectedValues, setSelectedValues, options }) {
  return (
    <select
      multiple
      value={selectedValues}
      onChange={(e) => {
        const selectedOptions = Array.from(
          e.target.selectedOptions,
          (option) => option.value
        )
        setSelectedValues(selectedOptions)
      }}
    >
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  )
}

export default CustomFilter

export const MultiSelectColumnFilter = ({
  column: { filterValue = [], setFilter, preFilteredRows, id }
}) => {
  const options = useMemo(() => {
    const uniqueOptions = new Set()
    preFilteredRows.forEach((row) => {
      uniqueOptions.add(row.values[id])
    })
    return [...uniqueOptions]
  }, [id, preFilteredRows])

  // Handle change in selected options
  const handleChange = (e) => {
    const selectedOptions = Array.from(
      e.target.selectedOptions,
      (option) => option.value
    )
    setFilter(selectedOptions)
  }

  return (
    <select multiple value={filterValue} onChange={handleChange}>
      <option value=''>All</option>
      {options.map((option, index) => (
        <option key={index} value={option}>
          {option}
        </option>
      ))}
    </select>
  )
}

export function DebouncedInput({
  value: initialValue,
  type,
  onChange,
  debounce = 1500,
  width,
  placeholder = '', hftid, tableId, column, side, arrayData,
  ...props
}) {
  const [value, setValue] = React.useState(initialValue)
  const { addFilterData } = CommonAPICall()
  const col0 = arrayData?.[0]
  const col1 = arrayData?.[1]
  var arrayValue = []
  let valuedata
  const resetValue = () => {
    if (side === 'left') {
      valuedata = ['', col1]
    } else if (side === 'right') {
      valuedata = [col0, '']
    }
    setValue('')
    addFilterData({
      hftUserId: hftid,
      tableName: tableId,
      clFilter: [
        {
          column: column,
          values: valuedata,
        },
      ],
    });

  }
  React.useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value)
    }, debounce)

    return () => clearTimeout(timeout)
  }, [value])


  const handleChange = (e) => {
    setValue(e.target.value)
  }

  return (
    <>
      <div className='flex'>
        <input
          type={type}
          {...props}
          value={value}
          // onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          onChange={handleChange}
          className={`p-1 px-2 border-2 border-solid rounded font-medium outline-none border-width: ${type === 'number' ? 'w-[55px]' : 'min-w-[110px]'
            } focus:border-blue-400`}
          style={{
            width: width,
            borderColor: 'hsl(0, 0%, 80%)'
          }}
        />

        {value !== '' && value !== undefined && (
          <button onClick={() => resetValue()}>
            <svg
              className='w-6 h-6 text-gray-800 dark:text-white'
              aria-hidden='true'
              xmlns='http://www.w3.org/2000/svg'
              fill='currentColor'
              viewBox='0 0 24 24'
            >
              <path
                fillRule='evenodd'
                d='M2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0Zm7.7-3.7a1 1 0 0 0-1.4 1.4l2.3 2.3-2.3 2.3a1 1 0 1 0 1.4 1.4l2.3-2.3 2.3 2.3a1 1 0 0 0 1.4-1.4L13.4 12l2.3-2.3a1 1 0 0 0-1.4-1.4L12 10.6 9.7 8.3Z'
                clipRule='evenodd'
              />
            </svg>
          </button>
        )}
      </div>
    </>
  )
}

export function DebouncedSelect({
  value: initialValue,
  options,
  onChange,
  debounce = 500,
  ...props
}) {
  const [value, setValue] = React.useState(initialValue)

  const resetValue = () => {
    setValue('')
  }

  React.useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value)
    }, debounce)

    return () => clearTimeout(timeout)
  }, [value])

  const handleChange = (selectedOptions) => {
    setValue(selectedOptions)
  }

  return (
    <>
      <Select
        {...props}
        options={options}
        value={value}
        onChange={handleChange}
      />
      {value && (
        <button onClick={resetValue}>
          <svg
            className='w-6 h-6 text-gray-800 dark:text-white'
            aria-hidden='true'
            xmlns='http://www.w3.org/2000/svg'
            fill='currentColor'
            viewBox='0 0 24 24'
          >
            <path
              fillRule='evenodd'
              d='M2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0Zm7.7-3.7a1 1 0 0 0-1.4 1.4l2.3 2.3-2.3 2.3a1 1 0 1 0 1.4 1.4l2.3-2.3 2.3 2.3a1 1 0 0 0 1.4-1.4L13.4 12l2.3-2.3a1 1 0 0 0-1.4-1.4L12 10.6 9.7 8.3Z'
              clipRule='evenodd'
            />
          </svg>
        </button>
      )}
    </>
  )
}

export const getMondayDate = (weekYearString) => {
  const [week, year] = weekYearString.split('.').map(Number)

  if (!week || !year) {
    return null // Invalid input
  }

  const januaryFirst = new Date(year, 0, 1)
  const daysToMonday = ((8 - januaryFirst.getDay()) % 7) + (week - 1) * 7

  const mondayDate = new Date(januaryFirst)
  mondayDate.setDate(januaryFirst.getDate() + daysToMonday)

  return mondayDate
}

export const actionCompSelector = (requestData, setShowChangeRequestBanner, setMessageForBanner, setShowAlert) => {
  let actionTaken = false
  if (requestData?.status?.toLowerCase() === 'open') {
    if (requestData?.supplier_response === 'Awaiting Response') {
      if (requestData?.request_type?.toLowerCase() === 'confirm') {
        return <ConfirmActionComp requestData={requestData}
          setShowChangeRequestBanner={setShowChangeRequestBanner} setMessageForBanner={setMessageForBanner} />
      } else if (requestData?.request_type?.toLowerCase() === 'reconfirm') {
        return <ReconfirmActionComp requestData={requestData}
          setShowChangeRequestBanner={setShowChangeRequestBanner} setMessageForBanner={setMessageForBanner} />
      } else if (
        requestData?.request_type?.toLowerCase() === 'expedite' ||
        requestData?.request_type?.toLowerCase() === 'divert' ||
        requestData?.request_type?.toLowerCase() === 'defer'
      ) {
        return <ExpediteActionComp requestData={requestData}
          setShowChangeRequestBanner={setShowChangeRequestBanner}
          setMessageForBanner={setMessageForBanner} setShowAlert={setShowAlert} />
      }
    } else if (requestData?.supplier_response === 'ACCEPTED') {
      actionTaken = true
    } else if (requestData?.supplier_response === 'REJECTED') {
      actionTaken = true
    }
  } else if (
    requestData?.status?.toLowerCase() === 'closed' ||
    requestData?.status?.toLowerCase() === 'canceled'
  ) {
    actionTaken = true
  }

  return actionTaken ? (
    <div className='flex justify-center items-center'>
      {requestData?.supplier_response === 'ACCEPTED' && (
        <svg
          className='w-6 h-6 text-green-600'
          title="Action"
          aria-hidden='true'
          xmlns='http://www.w3.org/2000/svg'
          fill='currentColor'
          viewBox='0 0 20 20'

        >
          <path d='M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z' />
        </svg>

      )}
      {requestData?.supplier_response === 'REJECTED' && (
        <svg
          className='w-6 h-6 text-red-500'
          aria-hidden='true'
          xmlns='http://www.w3.org/2000/svg'
          fill='currentColor'
          viewBox='0 0 20 20'
        >
          <path d='M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 11.793a1 1 0 1 1-1.414 1.414L10 11.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L8.586 10 6.293 7.707a1 1 0 0 1 1.414-1.414L10 8.586l2.293-2.293a1 1 0 0 1 1.414 1.414L11.414 10l2.293 2.293Z' />
        </svg>
      )}
    </div>
  ) : (
    <></>
  )
}

// export const getPresentShipWeek = () => {
//   var today = new Date()
//   // Calculate today's week no
//   // Make Sunday's day number 7
//   today.setUTCDate(today.getUTCDate() + 4 - (today.getUTCDay() || 7))
//   // Get first day of year
//   var yearStart = new Date(Date.UTC(today.getUTCFullYear(), 0, 1))
//   // Calculate full weeks to nearest Thursday
//   var currWeek = Math.ceil(((today - yearStart) / 86400000 + 1) / 7)
//   var year = today.getFullYear().toString().slice(-2)
//   return currWeek.toString() + '.' + year
// }

// If requested ship week in data is greater than today's ship day return requested ship day
// If today's week has passed requested ship week, return current week
// export const getPossibleShipWeek = (weekString) => {
//   if (!weekString)
//     return
//   const [requestedWeek, requestedYear] = weekString.split('.').map(Number);
//   const presentShipWeek = getPresentShipWeek();
//   const [presentWeek, presentYear] = presentShipWeek.split('.').map(Number);

//   if (presentYear < requestedYear || (presentYear === requestedYear && presentWeek < requestedWeek)) {
//     return weekString;
//   }
//   return presentShipWeek;
// };

// export const getPresentShipWeek = () => {
//   const today = new Date();
//   const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
//   const weekNumber = Math.ceil(((today - firstDayOfYear) / (7 * 24 * 60 * 60 * 1000)) + 1);
//   const year = today.getFullYear() % 100;

//   return `${weekNumber}.${year}`;
// };

export const getPresentShipWeek = () => {
  const today = new Date();
  const tempDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  // Set the date to Thursday of the current week (to ensure we are in the correct ISO week)
  const day = tempDate.getDay() || 7; // Make Sunday (0) become 7
  tempDate.setDate(tempDate.getDate() + 4 - day);
  const isoYear = tempDate.getFullYear();

  // Calculate the start of the ISO year
  const yearStart = new Date(isoYear, 0, 1);
  const dayOfYear = ((tempDate - yearStart) / 86400000) + 1; // Days since year start

  // Calculate the ISO week number
  const weekNumber = Math.ceil(dayOfYear / 7);
  return `${weekNumber}.${isoYear % 100}`;
};

export const getPossibleShipWeek = (weekString) => {
  if (!weekString) return null;

  const [requestedWeek, requestedYear] = weekString.split('.').map(Number);
  const presentShipWeek = getPresentShipWeek();
  const [presentWeek, presentYear] = presentShipWeek.split('.').map(Number);

  if (
    presentYear < requestedYear ||
    (presentYear === requestedYear && presentWeek < requestedWeek)
  ) {
    return weekString;
  }

  return presentShipWeek;
};





// for diferent screen size
export function isScreenTooSmall() {
  return window.innerWidth < 480; // You can adjust the pixel value as needed
}


export function isScreenBigForSideBar() {
  return window.innerWidth > 845; // You can adjust the pixel value as needed
}

export const getStartDate = (weekString, weekOffset = 0) => {
  if (!weekString) return null;

  let [week, year] = weekString.split('.').map(Number);
  week += weekOffset;

  // Adjust for two-digit year format
  year += 2000;

  // January 1st of the given year
  const januaryFirst = new Date(year, 0, 1);

  // Calculate the offset to the first Monday of the year
  const dayOffset = (8 - januaryFirst.getDay()) % 7;

  // Calculate the start date for the specified week
  const calculatedDate = new Date(
    januaryFirst.getTime() +
    (week - 1) * 7 * 24 * 60 * 60 * 1000 + // weeks to milliseconds
    dayOffset * 24 * 60 * 60 * 1000 // offset to first Monday
  );

  return calculatedDate;
};


export const nullOriginal = (requestedShipWeek) => {
  const [requestedWeek, requestedYear] = requestedShipWeek
    ?.split('.')
    ?.map(Number)
  const newWeek = requestedWeek + 4
  const originalShipWeek = `${newWeek}.${requestedYear}`
  return getStartDate(originalShipWeek)
}

export const updateActionHistory = (action, requestData) => {
  const user = JSON.parse(localStorage.getItem('userData'))
  const action_payload = []


  requestData?.map((request) => {
    const payload = {
      hftcrid:
        request?.potype === 'URGENT' && user?.roleName === 'SUPPLIER_ROLE'
          ? request?.idopenrequest
          : request?.id_open_request,
      po_number: request?.po_number,
      added_by_role_name: user?.roleName?.split('_')?.[0],
      added_by_name:
        user?.roleName?.split('_')?.[0]?.toLowerCase() === 'buyer'
          ? user?.fullName
          : user?.supplierName,
      comment: `Change Request ${action}`,
      type: 'Action',
      SKU: request?.sku
    }
    action_payload?.push(payload)
    return action_payload
  })
}

export const createUserPreference = (id) => {
  const clmnVisibility = JSON.parse(localStorage.getItem('toggle_columns'))
  const clmnFilter = JSON.parse(localStorage.getItem('column_filters'))
  const clmnOrder = JSON.parse(localStorage.getItem('po_list_order'))
  const payload = {
    hftUserId: id,
    poListColumns: clmnOrder,
    toggleColumns: clmnVisibility,
    clFilters: clmnFilter
  }

  axiosInstance
    .post(
      `${process.env.REACT_APP_API_DOMAIN}:${portInUseForAPI}/api/create-user-preference`,
      payload
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export const updateUserPreference = (id) => {
  const clmnVisibility = JSON.parse(localStorage.getItem('toggle_columns'))
  const clmnFilter = JSON.parse(localStorage.getItem('column_filters'))
  const clmnOrder = JSON.parse(localStorage.getItem('po_list_order'))
  const payload = {
    hftUserId: id,
    poListColumns: clmnOrder,
    toggleColumns: clmnVisibility,
    clFilters: clmnFilter
  }
}

export const getUserPreference = async (id) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_DOMAIN}:${portInUseForAPI}/api/get-user-preference-list?hftUserId=${id}`, ValidateAPI()
    )
    localStorage.setItem(
      'po_list_order',
      JSON.stringify(response?.data?.poListColumns)
    )
    localStorage.setItem(
      'column_filters',
      JSON.stringify(response?.data?.clFilters)
    )
    localStorage?.setItem(
      'toggle_columns',
      JSON.stringify(response?.data?.toggleColumns)
    )
    return response?.data
  } catch (error) {
    return null
  }
}

export const handleAcceptExpediteDeferRequests = (
  updateDataCount,
  setRequestData,
  selectedRowArray,
  loadingState,
  rejectModal,
  onSuccessCallback
) => {
  loadingState(true);
  const req_payload = [];
  const user = JSON.parse(localStorage.getItem('userData'));
  // const { updateDataCount } = CartState()
  selectedRowArray?.map((requestData) => {
    const payload = {
      id_open_request: requestData?.id_open_request,
      id_po_supplier_portal: Number(requestData?.id_po_supplier_portal),
      original_dc: requestData?.original_dc,
      requested_dc: requestData?.requested_dc,
      original_ship_week: Number(requestData?.original_ship_week),
      requested_ship_week: Number(requestData?.requested_ship_week),
      original_qty: requestData?.original_qty,
      requested_qty: requestData?.requested_qty,
      inventory_analyst_id: 1,
      current_ship_week: requestData?.request_type !== 'Divert' ? requestData?.requested_ship_week : requestData?.current_ship_week,
      vendor_selected_sw: requestData?.requested_ship_week !== null ? Number(requestData?.requested_ship_week) : null,
      supplier_contact_id: user?.vendorContactOrcaleId,
      on_time_target: requestData?.request_type !== 'Divert' ? requestData?.requested_ship_week : requestData?.on_time_target,
      ship_week_delay: Math.abs(
        weeksInBetween(
          requestData?.current_ship_week,
          requestData?.current_ship_week
        )
      ),
      reasonCodeId: null
    };
    req_payload?.push(payload);
    return req_payload;
  });

  axiosInstance
    .post(
      `${process.env.REACT_APP_API_DOMAIN}:${portInUseForAPI}/api/supplier-accept-request`,
      req_payload
    )
    .then((response) => {
      selectedRowArray?.map((requestData) => {
        return updateActionHistory('Accepted', [requestData]);
      });
      rejectModal(false);
      loadingState(false);
      notifyParent()
      updateDataCount(user?.supplierId)
      if (onSuccessCallback) onSuccessCallback(true, response.data);
      // window.location.reload();

    })
    .catch((err) => {
      rejectModal(false);
      loadingState(false);
      if (onSuccessCallback) onSuccessCallback(false);
      alert(i18next.t('PopUpMessage.ErrorwhileacceptingChangeRequestPleasetryagain'));
      // window.location.reload();
    });
};

function notifyParent() {
  if (window.opener) {
    window.opener.postMessage({ updated: true }, "*");
  }
}
export const handleRejectExpediteDeferDivertRequest = (
  additionalReasonForOther,
  updateDataCount,
  setRequestData,
  selectedRowArray,
  reasonCodeValue,
  setShowRejectModal,
  setreasonCodeValue,
  loadingState,
  onSuccessCallback

) => {
  if (!reasonCodeValue?.reasonCodeText?.length > 0)
    return alert(i18next.t('PopUpMessage.Pleaseselectareasoncode'))
  loadingState(true)
  const user = JSON.parse(localStorage.getItem('userData'))
  const req_payload = []
  selectedRowArray?.map((requestData, index) => {
    const payload = {
      id_open_request: requestData?.id_open_request,
      id_po_supplier_portal: requestData?.id_po_supplier_portal,
      original_dc: requestData?.original_dc,
      requested_dc: requestData?.requested_dc,
      original_ship_week: requestData?.original_ship_week,
      requested_ship_week: requestData?.requested_ship_week,
      reason_code_ship_week: requestData?.request_type !== 'Divert' ? reasonCodeValue?.reasonCodeText : '',
      reason_code_dc: requestData?.request_type === "Divert" ? reasonCodeValue?.reasonCodeText : '',
      reasonCodeId: reasonCodeValue?.reasonCodeId || "",
      original_qty: requestData?.original_qty,
      requested_qty: requestData?.original_qty,
      reason_code_qty: '',
      inventory_analyst_id: 1,
      supplier_contact_id: user?.vendorContactOrcaleId,
      current_ship_week: requestData?.current_ship_week,
      on_time_target: requestData?.on_time_target,
      status: 'Closed',
      other_reason_description: additionalReasonForOther
    }
    req_payload?.push(payload)
    return req_payload
  })

  axiosInstance
    .post(
      `${process.env.REACT_APP_API_DOMAIN}:${portInUseForAPI}/api/supplier-reject-request`,
      req_payload
    )
    .then((response) => {

      selectedRowArray?.map((requestData) => {
        return updateActionHistory('Rejected', [requestData])
      })
      setRequestData(response?.data)
      loadingState(false)
      setShowRejectModal(false)
      setreasonCodeValue({
        "reasonCodeId": "",
        "reasonCodeText": ""
      })
      if (onSuccessCallback) onSuccessCallback(true, response.data)
      updateDataCount(user?.supplierId)
      notifyParent()
      // alert(i18next.t('PopUpMessage.ChangeRequestrejectedsuccessfully'))
      // window.location.reload()
    })
    .catch((error) => {
      if (onSuccessCallback) onSuccessCallback(true)
      alert(
        i18next.t('PopUpMessage.ErrorwhilerejectingChangeRequestPleasetryagain')
      )
      loadingState(false)
      setShowRejectModal(false)
      // window.location.reload();
    })
}
const token = Cookies.get('idcs_user_assertion')
const role = Cookies.get('role')
const getToken = () => {
  return Cookies.get('idcs_user_assertion')
}
const user = JSON.parse(localStorage.getItem('userData'))
const auth_id = localStorage.getItem('auth_state')

 const getNewAuthData = () => {
  const user = JSON.parse(localStorage.getItem('userData')) || {};
  const role = (Cookies.get('role') || "").toLowerCase();
  const auth_id = localStorage.getItem('auth_state') || "";
  const token = Cookies.get("idcs_user_assertion") || "";
  return { user, role, auth_id, token };
};

export const ValidateAPI = () => {
  const { user, role, auth_id } = getNewAuthData();
  
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${Cookies.get('idcs_user_assertion')}`,
    'Role': role,
    'X-Trace-Id': auth_id
  };

  // Only append X-Source-Ref if it's a vendor and the ID exists
  if ((role?.toLowerCase() === "vendor" && user?.supplierId) ) {
    headers["X-Source-Ref"] = user.supplierId ;
  } else if(role?.toLowerCase() === "buyer" && user?.hftOracleId){
    headers["X-Source-Ref"] = user.hftOracleId ;
  }

  return { headers };
};

export const getallDcList = async () => {
  const { user, role, auth_id, token } = getNewAuthData();
  // User is not authenticated yet
  if (!token || !auth_id || !role) {
    return false;
  }
  if (isTokenExpired(token)) {
    console.warn("getallDcList: Blocked. Token has expired.");
    return false;
  }

  // userData has not been populated yet
  if (!user || Object.keys(user).length === 0) {
    return false;
  }
  // If role is vendor, we REQUIRE supplierId.
  // If role is not vendor , we proceed without it.
      const isVendor = role === 'vendor';
      const isBuyer = role === 'buyer';

  if ((isVendor && !user?.supplierId) || (isBuyer && !user?.hftOracleId)) {
    console.warn("getallDcList: Blocked. Required ID's missing.");
    return false;
  }

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_DOMAIN}:${portInUseForAPI}/api/get-dc-list`,
      ValidateAPI()
    );

    if (response?.data) {
      sessionStorage.setItem('dcList', JSON.stringify(response?.data));
      return true;
    }
  } catch (error) {
    console.error("DC List Fetch Error:", error);
    return false;
  }
};
export const checkstatus = (value) => {
  if (value === 'N') return 'Not Processed'
  else if (value === 'I') return 'In Progress'
  else if (value === 'P') return 'Processed'
  else if (value === 'E') return 'Closed With Exception'
  else if (value === 'NA') return 'Not Applicable'
}

export function getCookie(name) {
  return Cookies.get(name);
}

export function setCookie(name, value, options = {}) {
  Cookies.set(name, value, options);
}

export function deleteCookie(name) {
  Cookies.remove(name);
}

export function getLocalStorageItem(key) {
  return localStorage.getItem(key);
}

export function clearLocalStorage() {
  localStorage.clear();
}
export function useOutsideClick(ref, callback) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, callback]);
}
// Normalize a Date to local date-only (00:00:00 local)
function toLocalDateOnly(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

// Safe parse for either Date object or parseable string/number
function asDate(value) {
  if (value instanceof Date) return value;
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

/**
 * dateFilterFn(row, id, value)
 * value is expected to be: { start?: string|Date, end?: string|Date }
 * - When using <input type="date">, start/end are typically "YYYY-MM-DD" (local).
 * - Works with Date objects too.
 */
export function DatefilterFn(row, id, value) {
  // Cell raw value from API (keep it raw in accessorKey)
  const raw = row.getValue(id);
  if (raw == null) return false; // exclude rows without a date

  const cellDateRaw = asDate(raw);
  if (!cellDateRaw) return false;

  // Convert cell to local date-only
  const cellLocal = toLocalDateOnly(cellDateRaw);

  // Parse filter start/end (allow string or Date)
  const startRaw = value && value.start != null ? asDate(value.start) : null;
  const endRaw   = value && value.end   != null ? asDate(value.end)   : null;

  // If both bounds are missing, do not filter out anything
  if (!startRaw && !endRaw) return true;

  const startLocal = startRaw ? toLocalDateOnly(startRaw) : null;
  const endLocal   = endRaw   ? toLocalDateOnly(endRaw)   : null;

  // Inclusive range on date-only
  if (startLocal && cellLocal < startLocal) return false;
  if (endLocal && cellLocal > endLocal) return false;

  return true;
}

export function SingleDateFilterFn(row, id, value) {
  const raw = row.getValue(id);

  if (!raw || raw === 'BLANK') return false;

  const cellDate = asDate(raw);

  if (!cellDate) return false;

  const cellLocal = toLocalDateOnly(cellDate);

  const selectedValues = Array.isArray(value)
    ? value
    : String(value ?? '').split(',');

  return selectedValues.some(filterValue => {
    const filterDate = asDate(filterValue.trim());

    if (!filterDate) return false;

    return (
      cellLocal.getTime() ===
      toLocalDateOnly(filterDate).getTime()
    );
  });
}
// calculate ship week no of the year
export function getWeekOfTheYear(date) {
  const currentDate = new Date(date)
  const currentYear = currentDate.getFullYear()
  const firstDayOfYear = new Date(currentYear, 0, 1)
  const days = Math.round(
    (currentDate - firstDayOfYear) / (24 * 60 * 60 * 1000)
  )
  let weekNumber = Math.ceil((days + firstDayOfYear.getDay() + 1) / 7)
  weekNumber = weekNumber === 53 ? 1 : weekNumber
  return `${weekNumber}.${currentYear % 100}`
}


export function changeDateFormat(inputWeekYear) {
  if (!inputWeekYear)
    return
  const [isoWeek, isoYear] = inputWeekYear.split('.')
  const fullYear = `20${isoYear.padStart(2, '0')}`
  const firstThursday = new Date(fullYear, 0, 4);
  firstThursday.setDate(firstThursday.getDate() + 3 - (firstThursday.getDay() + 6) % 7);

  // // Calculate the date of the first day of the ISO week
  const daysFromFirstThursday = (isoWeek - 1) * 7;

  // // The first day of the given ISO week
  const date = new Date(firstThursday);
  date.setDate(firstThursday.getDate() + daysFromFirstThursday - 3); // Adjusting to get Monday of that week
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based, so add 1
  const day = date.getDate().toString().padStart(2, '0');
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;

}
export function filterFnSWDate(row, id, value) {
  const reqSwDate = row.getValue(id) // Assuming the column value is in ww.yy format
  if (!reqSwDate) {
    // Handle the case where reqSwDate is null or undefined
    return false // Or return any default value based on your logic
  }

  const start = new Date(value.start)
  const end = new Date(value.end)
  const paramValue = row.getValue(id)
  // if (!paramValue) return ''

  const day = paramValue?.slice(3, 5)
  const month = paramValue?.slice(0, 2)
  const year = paramValue?.slice(6, 10)
  const formattedDate = `${month}-${day}-${year}`
  const data = new Date(formattedDate)

  return data >= start && data <= end;
}



export function CalculateTableArray(limit, arr = []) {
  let temp = 10; // Starting value for temp
  const value = (limit, arr = []) => {
    if (temp > limit) {
      if (arr[arr.length - 1] !== limit) { 
         arr.push(limit);
      }
      return arr; // Return the array
    }
    if (temp > 100) {
      if (arr[arr.length - 1] !== limit) {
        arr.push(limit);
      }
      return arr;
    }
    arr.push(temp); // Store the current value of temp in the array
    temp += 10; // Increment temp by 10
    return value(limit, arr);
  } // Recursive call with the updated array
  return value(limit)
};
export function highLightDateField(currSW) {
  if (!currSW)
    return
  const value = [currSW && { 'bg-green-500 rounded-md': [new Date(changeDateFormat(currSW))] }]
  return value

}
export function OpenSpecificDate(currSW) {
  return currSW && getStartDate(getPossibleShipWeek(currSW))
}


export function getDateofMonday(inputWeekYear) {

  if (!inputWeekYear)
    return
  const [isoWeek, isoYear] = inputWeekYear.split('.')
  const fullYear = `20${isoYear.padStart(2, '0')}`
  const firstThursday = new Date(fullYear, 0, 4);
  firstThursday.setDate(firstThursday.getDate() + 3 - (firstThursday.getDay() + 6) % 7);

  // // Calculate the date of the first day of the ISO week
  const daysFromFirstThursday = (isoWeek - 1) * 7;

  // // The first day of the given ISO week
  const date = new Date(firstThursday);
  date.setDate(firstThursday.getDate() + daysFromFirstThursday - 3); // Adjusting to get Monday of that week
  date.setHours(1, 1, 1, 1);
  return date;


}

export const validateSWforBooking = (value, currentShipWeek) => {
  const regex = /^\d{1,2}\.\d{2}$/;
  if (!regex.test(value)) {
    // Return as valid if format is incomplete
    return { isValid: false, message: "" };
  }

  const [weekStr, yearStr] = value.split('.');
  const week = parseInt(weekStr, 10);
  const year = parseInt(yearStr, 10) + 2000; // Convert YY to YYYY

  const [currentWeekStr, currentYearStr] = currentShipWeek.split('.');
  const currentWeek = parseInt(currentWeekStr, 10);
  const currentYear = parseInt(currentYearStr, 10) + 2000;
  const presentShipWeek = getPresentShipWeek();
  const [presentWeek, presentYearStr] = presentShipWeek.split('.').map(Number);
  const presentYear = parseInt(presentYearStr, 10) + 2000;
  const getWeeksInYear = (year) => {
    const jan1 = new Date(year, 0, 1);
    const dec31 = new Date(year, 11, 31);

    const dayOfJan1 = jan1.getDay(); // Day of the week for January 1
    const dayOfDec31 = dec31.getDay(); // Day of the week for December 31

    // 53 weeks if the year starts on Thursday OR it's a leap year starting on Wednesday
    const isLeapYear = (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0));

    if (dayOfJan1 === 4 || (isLeapYear && dayOfJan1 === 3)) {
      return 53;
    }

    return 52;
  };
  const maxWeek = getWeeksInYear(year);

  if (week > maxWeek) {
    return { isValid: false, message: 'Invalid week number for the given year.' };
  }

  if (year === currentYear && week === currentWeek) {
    return { isValid: true, message: 'Week number matches the current ship week.' };
  } else if (year < presentYear || (week <= presentWeek && year === presentYear)) {
    return { isValid: false, message: 'Week number is in the past.' };
  }
  // else if (week < presentWeek && year === presentYear) {
  //   return { isValid: false, message: 'Week number is in the past.' };
  // }
  else {
    return { isValid: true, message: "" };
  }
};
//this is for my pos 
export const validateShipWeekInput1 = (value, currentShipWeek) => {
  const regex = /^\d{1,2}\.\d{2}$/;
  if (!regex.test(value)) {
    return { isValid: false, message: "" };
  }

  const [weekStr, yearStr] = value.split('.');
  const week = parseInt(weekStr, 10);
  const year = parseInt(yearStr, 10) + 2000; // 26 => 2026

  const [currentWeekStr, currentYearStr] = currentShipWeek.split('.');
  const currentWeek = parseInt(currentWeekStr, 10);
  const currentYear = parseInt(currentYearStr, 10) + 2000;

  const presentShipWeek = getPresentShipWeek();

  // FIX: Convert present year to 4-digit
  const [presentWeekStr, presentYearStr] = presentShipWeek.split('.');
  const presentWeek = parseInt(presentWeekStr, 10);
  const presentYear = parseInt(presentYearStr, 10) + 2000;

  const getWeeksInYear = (year) => {
    const jan1 = new Date(year, 0, 1);
    const isLeapYear = (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0));
    const dayOfJan1 = jan1.getDay();
    return (dayOfJan1 === 4 || (isLeapYear && dayOfJan1 === 3)) ? 53 : 52;
  };

  const maxWeek = getWeeksInYear(year);

  if (week > maxWeek) {
    return { isValid: false, message: 'Invalid week number for the given year.' };
  }

  if (year === currentYear && week === currentWeek) {
    return { isValid: false, message: 'Week number matches the current ship week.' };
  }

  if (year < currentYear || (year === currentYear && week <= currentWeek)) {
    return { isValid: false, message: 'Week number is in the past.' };
  }

  if (year === presentYear && week <= presentWeek) {
    return { isValid: false, message: 'Week number is in the past.' };
  }
  const inputDate = getDateofMonday(value);

  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() + 2);

  if (inputDate > maxDate) {
    return {
      isValid: false,
      message: "Week is beyond allowed future limit (2 years).",
    };
  }

  return { isValid: true, message: "" };
};



export const validateShipWeekInput = (value, currentShipWeek) => {
  const regex = /^\d{1,2}\.\d{2}$/;
  if (!regex.test(value)) {
    return { isValid: false, message: "" };
  }

  const [weekStr, yearStr] = value.split(".");
  const week = parseInt(weekStr, 10);
  const year = 2000 + parseInt(yearStr, 10);

  const today = new Date();
  const todayYear = today.getFullYear();

  // Calculate today's week number
  const startOfYear = new Date(todayYear, 0, 1);
  const daysDifference = Math.floor((today - startOfYear) / (24 * 60 * 60 * 1000));
  const todayWeek = Math.ceil((daysDifference + startOfYear.getDay() + 1) / 7);

  // Helper - number of weeks in given year
  const getWeeksInYear = (year) => {
    const jan1 = new Date(year, 0, 1);
    const dayOfJan1 = jan1.getDay();
    const isLeapYear = (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0));
    return (dayOfJan1 === 4 || (isLeapYear && dayOfJan1 === 3)) ? 53 : 52;
  };

  const maxWeek = getWeeksInYear(year);

  // ❌ Invalid week number
  if (week < 1 || week > maxWeek) {
    return { isValid: false, message: "" };
  }

  // --- NEW LOGIC ---

  // ❌ Reject past years
  if (year < todayYear) {
    return { isValid: false, message: "" };
  }

  // ❌ Reject current year but past or current week
  if (year === todayYear && week <= todayWeek) {
    return { isValid: false, message: "" };
  }

  // ❌ Only allow up to 2 years ahead
  const maxAllowedYear = todayYear + 2;
  if (year > maxAllowedYear) {
    return { isValid: false, message: "" };
  }
  
  if (currentShipWeek) {
    const enteredSW = value.trim();
    const existingSW = String(currentShipWeek).trim();

    if (enteredSW === existingSW) {
      return { isValid: false, message: "" };
    }
  }
  // If year is maxAllowedYear, week must be valid within that year (handled above)

  return { isValid: true, message: "" };
};

//to make ship week on ww.yy format 
export const makeSWformat = (weekYear) => {
  const sw = weekYear?.split('.')
  return sw[0].padStart(2, '0') + "." + sw[1]
}
export const multipleReasonCode = [
  {
    type: 'common',
    reasonEN: 'Capacity or Production Slow Down',
    reasonMN: "产能或生产放缓"
  },
  {
    type: 'common',
    reasonEN: 'Equipment/Mold Maintenance',
    reasonMN: "设备/模具维护"
  },
  {
    type: 'common',
    reasonEN: 'LCL Shipment Consolidation',
    reasonMN: "拼箱货物整合"
  },
  {
    type: 'common',
    reasonEN: 'Material or Labor Shortage',
    reasonMN: "材料或劳动力短缺"
  },
  {
    type: 'common',
    reasonEN: 'Public Holiday',
    reasonMN: "公共假期"
  },
  {
    type: 'common',
    reasonEN: 'Quality Issue / Product Change',
    reasonMN: "质量问题/产品变更"
  },
  {
    type: 'common',
    reasonEN: 'Force Majeure / Weather Events',
    reasonMN: "不可抗力/天气事件"
  },
  {
    type: 'common',
    reasonEN: 'Freight Forwarder Consolidation',
    reasonMN: "货运代理整合"
  },
  {
    type: 'common',
    reasonEN: 'Vessel Delay',
    reasonMN: "空间限制"
  },
  //divert reason code
  {
    type: 'Divert',
    reasonEN: 'Packaging/Carton Printed',
    reasonMN: 'Packaging Printed'
  },
  {
    type: 'Divert',
    reasonEN: 'Shipping Space Booked',
    reasonMN: 'Shipping Space Booked'
  },
  {
    type: 'Divert',
    reasonEN: 'Vessel Departure',
    reasonMN: 'Vessel Departure',
  },
  {
    type: 'Divert',
    reasonEN: 'Custom Clearance Completed',
    reasonMN: "Custom Clearance Completed",

  },
  {
    type: 'Divert',
    reasonEN: 'Others',
    reasonMN: "Others",
  },
  //quantity reason code
  {
    type: 'ConfirmQTY',
    reasonEN: 'Master Carton QTY',
    reasonMN: 'Master Carton QTY',

  },
  {
    type: 'ConfirmQTY',
    reasonEN: 'MOQ',
    reasonMN: "MOQ",
  },
  {
    type: 'ConfirmQTY',
    reasonEN: 'FCL',
    reasonMNL: "FCL",
  },
  //defer reason code
  {
    type: 'Defer',
    reasonEN: 'Finished and limited storage space',
    reasonMN: "Finished and limited storage space",
  },
  {
    type: 'Defer',
    reasonEN: 'Shipping Space Booked',
    reasonMN: "Shipping Space Booked",
  },
  {
    type: 'Defer',
    reasonEN: 'Delivered to forwarder warehouse',
    reasonMN: "Delivered to forwarder warehouse",
  },
  {
    type: 'Defer',
    reasonEN: 'LCL Shipment Consolidation',
    reasonMN: "LCL Shipment Consolidation",
  },
  {
    type: 'Defer',
    reasonEN: 'Cash Flow Issue',
    reasonMN: "Cash Flow Issue",
  },
  {
    type: 'Defer',
    reasonEN: 'Vessel Departure',
    reasonMN: "Vessel Departure",
  },
  {
    type: 'Defer',
    reasonEN: 'Others',
    reasonMN: "Others",
  },
  //delay reason code
  {
    type: 'Delay',
    reasonEN: 'FAT',
    reasonMN: "FAT",
  },
  {
    type: 'Delay',
    reasonEN: 'ArtWork',
    reasonMN: "ArtWork",
  },
  {
    type: 'Delay',
    reasonEN: 'Product Change',
    reasonMN: "Product Change",
  },
  {
    type: 'Delay',
    reasonEN: 'Short Lead Time',
    reasonMN: "Short Lead Time",
  },
  {
    type: 'Delay',
    reasonEN: 'Inspection Delay',
    reasonMN: "Inspection Delay",
  },
  {
    type: 'Delay',
    reasonEN: 'Space Constraints',
    reasonMN: "Space Constraints",
  },
  {
    type: 'Delay',
    reasonEN: 'Capacity',
    reasonMN: "Capacity",
  },
  {
    type: 'Delay',
    reasonEN: 'Material Shortage',
    reasonMN: "Material Shortage",
  },
  {
    type: 'Delay',
    reasonEN: 'Quality Issue',
    reasonMN: "Quality Issue",
  },
  {
    type: 'Delay',
    reasonEN: 'Public Holiday',
    reasonMN: "Public Holiday",
  },
  {
    type: 'Delay',
    reasonEN: 'Production Slow Down',
    reasonMN: "Production Slow Down",
  },
  {
    type: 'Delay',
    reasonEN: 'Partial Shipment',
    reasonMN: "Partial Shipment",
  },
  {
    type: 'Delay',
    reasonEN: 'Mold/Equipment Maintenance',
    reasonMN: "Mold/Equipment Maintenance",
  },
  {
    type: 'Delay',
    reasonEN: 'MOQ',
    reasonMN: "MOQ",
  },
  {
    type: 'Delay',
    reasonEN: 'LCL Shipment Consolidation',
    reasonMN: "LCL Shipment Consolidation",
  },
  {
    type: 'Delay',
    reasonEN: 'Labor Storage',
    reasonMN: "Labor Storage",
  },
  {
    type: 'Delay',
    reasonEN: 'Force majeure',
    reasonMN: "Force majeure",
  },

  {
    type: 'Delay',
    reasonEN: ' Environment/Power Rationing',
    reasonMN: " Environment/Power Rationing",
  },
  {
    type: 'Delay',
    reasonEN: 'Others',
    reasonMN: "Others",
  },

]

export const convertToLocalDate = (dateStr) => {
  if (!dateStr) return "";

  // Remove AM/PM if time is already 24-hour
  const normalized = dateStr.replace(
    /(\b\d{2}:\d{2}:\d{2})\s*(AM|PM)$/i,
    (match, time, meridiem) => {
      const hour = parseInt(time.split(":")[0], 10);
      return hour > 12 ? time : match;
    }
  );

  const d = new Date(normalized);
  if (isNaN(d)) return "";

  const pad = (n) => n.toString().padStart(2, "0");

  const year = d.getFullYear();
  const month = pad(d.getMonth() + 1);
  const day = pad(d.getDate());

  const hours24 = pad(d.getHours());
  const minutes = pad(d.getMinutes());
  const seconds = pad(d.getSeconds());

  const ampm = d.getHours() >= 12 ? "PM" : "AM";

  return `${month}/${day}/${year} ${hours24}:${minutes}:${seconds} ${ampm}`;
};




export function formatShipWeek(value) {
  if (!value) return value;

  const [week, year] = value.split(".");

  // pad week (W → WW)
  const paddedWeek = week.padStart(2, "0");

  return `${paddedWeek}.${year}`;
}

export const getAbsoluteExpiry = ({ expTime, expiresIn }) => {
  if (expiresIn) {
      return Date.now() + expiresIn * 1000;
  }

  if (expTime) {
      if (typeof expTime === "number") return expTime;
      if (!isNaN(expTime)) return Number(expTime);

      const parsed = new Date(expTime).getTime();
      if (!isNaN(parsed)) return parsed;
  }

  return null;
};

export const getBanners = async () => {
  try {
    const res = await axiosInstance.get('/api/admin/activeBanner');
    return res?.data?.data || []; 
  } catch (error) {
    console.error("Error fetching banners:", error);
    throw error; 
  }
};

export const  CommonReasonTextarea = ({
  value,
  error,
  onChange,
  setErrorMessage,
  placeholder = "Type your message...",
  rows = 5,
}) => {
  const MAX_LENGTH = 501

  const handleChange = (e) => {
    // Allow only letters, numbers and spaces
    const filteredValue = e.target.value;
    const specialCharRegex = /[^a-zA-Z0-9\s.,!?_-]/;
                    
    if (specialCharRegex.test(filteredValue)) {
      setErrorMessage('Special characters are not allowed.')
    } else if(filteredValue?.length > 500){
      setErrorMessage("Maximum 500 characters allowed")
    } else {
      setErrorMessage('')
    }

    onChange({
      ...e,
      target: {
        ...e.target,
        value: filteredValue,
      },
    });
  };

  return (
    <div className="w-full flex flex-col">
      <label className="text-xs font-medium block mb-2 text-left">
        Message <span className="required text-red-500">*</span>
      </label>

      <textarea
        rows={rows}
        className={`w-full p-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 resize-none
          ${
            error
              ? "border-red-500 focus:ring-red-500"
              : "border-gray-300 focus:ring-blue-500 focus:border-transparent"
          }`}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        maxLength={MAX_LENGTH}
      />
       
      <div className="mt-1 flex justify-between items-center">
        <div>
      {error && (
        <p className="text-red-500 text-xs font-medium">
          {error}
        </p>
      )}
        </div>

        <p className="text-xs text-gray-500">
          {value.length}/{500}
        </p>
      </div>
    </div>
  );
};


